import { OtherCompensationKind, OtherCompensationUsecase, UserDefinedRow } from "../../model";
import { IncomeTypeMetadata, IncomeTypesLogic, } from "../../logic";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";

/** Client-side logic for OtherCompensationUsecase  */
export class OtherCompensationUsecaseLogic extends BaseUsecaseLogic {
  /** Gets validation message  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage | undefined {
    const data: OtherCompensationUsecase = row.data || {};
    const codeData = this.getCodeData(data.kind);
    if (!codeData) {
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noIrIncomeType",
      };
    }
    return undefined;
  }

  private getCodeData(kind: OtherCompensationKind | null | undefined): IncomeTypeMetadata | undefined {
    if (kind) {
      let code = 0;
      switch (kind) {
        case OtherCompensationKind.MeetingFee:
          code = 210;
          break;
        case OtherCompensationKind.LectureFee:
          code = 214;
          break;
        case OtherCompensationKind.PositionOfTrustCompensation:
          code = 215;
          break;
        case OtherCompensationKind.AccruedTimeOffCompensation:
          code = 225;
          break;
        case OtherCompensationKind.MembershipOfGoverningBodyCompensation:
          code = 308;
          break;
        case OtherCompensationKind.MonetaryGiftForEmployees:
          code = 310;
          break;
        case OtherCompensationKind.UseCompensationAsEarnedIncome:
          code = 313;
          break;
        case OtherCompensationKind.UseCompensationAsCapitalIncome:
          code = 314;
          break;
        case OtherCompensationKind.OtherTaxableIncomeAsEarnedIncome:
          code = 316;
          break;
        case OtherCompensationKind.StockOptionsAndGrants:
          code = 320;
          break;
        case OtherCompensationKind.EmployeeInventionCompensation:
          code = 326;
          break;
        case OtherCompensationKind.CapitalIncomePayment:
          code = 332;
          break;
        case OtherCompensationKind.WorkEffortBasedDividendsAsWage:
          code = 339;
          break;
        case OtherCompensationKind.WorkEffortBasedDividendsAsNonWage:
          code = 340;
          break;
        case OtherCompensationKind.EmployeeStockOption:
          code = 343;
          break;
        case OtherCompensationKind.EmployeeStockOptionWithLowerPrice:
          code = 361;
          break;
        case OtherCompensationKind.CopyrightRoyaltiesEarnedIncome:
          code = 366;
          break;
        case OtherCompensationKind.StockGrantPaidInMoney:
          code = 367;
          break;
        case OtherCompensationKind.EmployeeStockOptionPaidInMoney:
          code = 368;
          break;
        case OtherCompensationKind.Undefined:
        default:
          code = 0;
          break;
      }
      return IncomeTypesLogic.getAll().find((x) => x.code === code);
    }
    return undefined;
  }

  private isIrIncomeTypeLabel(label: string): boolean {
    return IncomeTypesLogic.getAll().some((x) => x.label === label);
  }
}
